import { createFilledIcon } from "../createIcon";

export const PencilFilledIcon = createFilledIcon(
  <>
    <path d="M13.112 6.41c.439-.439 1.151-.439 1.59 0l2.889 2.888c.44.44.44 1.152 0 1.591l-8.98 8.979-4.835 1.116a.633.633 0 0 1-.759-.76l1.116-4.835 8.979-8.979Zm2.298-.707a1.125 1.125 0 0 1 0-1.59l.37-.37A2.524 2.524 0 0 1 17.57 3c.65 0 1.297.248 1.792.743l.896.896c.99.989.99 2.593 0 3.583l-.369.37c-.44.439-1.152.439-1.591 0L15.41 5.702Z" />
  </>,
  "PencilFilledIcon"
);
